import ArrowIcon from './svg/Icon.arrow'
import ArrowUpIcon from './svg/Icon.arrow.up'
import ArrowRightIcon from './svg/Icon.arrow.right'
import ArrowDownIcon from './svg/Icon.arrow.down'
import ArrowLeftIcon from './svg/Icon.arrow.left'
import ArrowsIcon from './svg/Icon.arrows'
import BellIcon from './svg/Icon.bell'
import CheckCircleIcon from './svg/Icon.check.circle'
import CheckInCircle from './svg/Icon.check.in.circle'
import ChevronIcon from './svg/Icon.chevron'
import ClipboardIcon from './svg/Icon.clipboard'
import ClockIcon from './svg/Icon.clock'
import ClockReverseIcon from './svg/Icon.clock.reverse'
import ClockHandsIcon from './svg/Icon.clock.hands'
import CloseIcon from './svg/Icon.close'
import EllipsisIcon from './svg/Icon.ellipsis'
import ExternalIcon from './svg/Icon.external'
import GearIcon from './svg/Icon.gear'
import JobsOutlineIcon from './svg/Icon.jobs.outline'
import JobsSolidIcon from './svg/Icon.jobs.solid'
import LinkIcon from './svg/Icon.link'
import LockClosedIcon from './svg/Icon.lock.closed'
import LockOpenIcon from './svg/Icon.lock.open'
import MiniLogoIcon from './svg/Icon.logo.mini'
import logooutIcon from './svg/Icon.logout'
import MWithQuestionIcon from './svg/Icon.m.question'
import MagnifyingGlassIcon from './svg/Icon.magnifying.glass'
import MagnifyingGlassSolidIcon from './svg/Icon.magnifying.glass.solid'
import MinusIcon from './svg/Icon.minus'
import OutboxIcon from './svg/Icon.outbox'
import PencilIcon from './svg/Icon.pencil'
import PersonPlusIcon from './svg/Icon.person.plus'
import PlusCircleIcon from './svg/Icon.plus.circle'
import QuestionSolidIcon from './svg/Icon.question.solid'
import QuestionIcon from './svg/Icon.question'
import RatingsGuideIcon from './svg/Icon.ratings.guide'
import ReviewsIcon from './svg/Icon.reviews'
import ReviewsSolidIcon from './svg/Icon.reviews.solid'
import ShareIcon from './svg/Icon.share'
import shieldOutlineIcon from './svg/Icon.shield.outline'
import ShieldStarIcon from './svg/Icon.shield.star'
import SkillsOutlineIcon from './svg/Icon.skills.outline'
import SkillsSolidIcon from './svg/Icon.skills.solid'
import SpeechBubbleOutlineIcon from './svg/Icon.speech.bubble.outline'
import TrashCanIcon from './svg/Icon.trash'
import TriangleIcon from './svg/Icon.triangle'
import WorkOutlineIcon from './svg/Icon.work.outline'
import WorkSolidIcon from './svg/Icon.work.solid'
import { SkipIcon } from './svg/icon.skip'
import XIcon from './svg/Icon.x'
import KudosThumbIcon from './svg/Icon.kudos.thumb'

const iconMap = {
	arrow: ArrowIcon,
	arrowUp: ArrowUpIcon,
	arrowRight: ArrowRightIcon,
	arrowDown: ArrowDownIcon,
	arrowLeft: ArrowLeftIcon,
	arrows: ArrowsIcon,
	bell: BellIcon,
	checkCircle: CheckCircleIcon,
	checkInCircle: CheckInCircle,
	chevron: ChevronIcon,
	clipboard: ClipboardIcon,
	clock: ClockIcon,
	clockHands: ClockHandsIcon,
	clockReverse: ClockReverseIcon,
	close: CloseIcon,
	ellipsis: EllipsisIcon,
	external: ExternalIcon,
	gear: GearIcon,
	kudosThumb: KudosThumbIcon,
	jobs: JobsOutlineIcon,
	jobsSolid: JobsSolidIcon,
	link: LinkIcon,
	lockClosed: LockClosedIcon,
	lockOpen: LockOpenIcon,
	logo: MiniLogoIcon,
	logout: logooutIcon,
	magnifyingGlass: MagnifyingGlassIcon,
	magnifyingGlassSolid: MagnifyingGlassSolidIcon,
	minus: MinusIcon,
	mWithQuestion: MWithQuestionIcon,
	outbox: OutboxIcon,
	pencil: PencilIcon,
	personPlus: PersonPlusIcon,
	plusCircle: PlusCircleIcon,
	question: QuestionIcon,
	questionSolid: QuestionSolidIcon,
	ratingsGuide: RatingsGuideIcon,
	skip: SkipIcon,
	speechBubble: SpeechBubbleOutlineIcon,
	reviewsSolid: ReviewsSolidIcon,
	reviews: ReviewsIcon,
	share: ShareIcon,
	shieldOutline: shieldOutlineIcon,
	shieldStar: ShieldStarIcon,
	skills: SkillsOutlineIcon,
	skillsSolid: SkillsSolidIcon,
	trash: TrashCanIcon,
	triangle: TriangleIcon,
	work: WorkOutlineIcon,
	workSolid: WorkSolidIcon,
	x: XIcon,
}
export default iconMap
